import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AnimatedSection from "@/components/base/AnimatedSection";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import SEOGuidesSection from "./components/SEOGuidesSection";
import AboutDarkSection from "./components/AboutDarkSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://mulebuyspreadsheets.quest";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "MuleBuy Spreadsheet Hub",
              description: "Discover, compare, and use the most reliable mulebuy spreadsheet lists to find trending products, trusted agents, and optimized buying strategies in 2026.",
              url: siteUrl,
              publisher: {
                "@type": "Organization",
                name: "MuleBuy Spreadsheet Hub",
              },
              mainEntity: {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "What is a mulebuy spreadsheet?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "A mulebuy spreadsheet is a curated product listing system used to organize items from China-based shopping agents. It contains structured data including product names, prices, supplier information, QC photos, and direct purchase links.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is using a mulebuy spreadsheet safe?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Safety depends on the source and curation quality of the mulebuy spreadsheet. Trusted mulebuy spreadsheets are regularly updated, verified by experienced agents, and include transparent product information.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How often are mulebuy spreadsheets updated?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Most high-quality mulebuy spreadsheets are updated daily or weekly to reflect current inventory, pricing changes, and trending products.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How do I choose the right mulebuy spreadsheet?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Consider the product categories you are interested in, the update frequency, agent reputation, and spreadsheet organization. Start with a trusted mulebuy spreadsheet list and compare multiple sources.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I use a mulebuy spreadsheet for bulk ordering?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, mulebuy spreadsheets are particularly useful for bulk ordering. They allow you to compare prices across multiple products, consolidate orders, and communicate with agents using structured product references.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What product categories are available in mulebuy spreadsheets?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Mulebuy spreadsheets cover virtually all product categories including shoes, hoodies and sweaters, t-shirts, jackets, pants and shorts, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes, and many more.",
                    },
                  },
                ],
              },
            }),
          }}
        />
        <HeroSection />
        <AnimatedSection delay={100}>
          <CategoryGrid />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <AboutDarkSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <SEOGuidesSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <FAQSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <CTASection />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
}